import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export default function CasNavLink({to, children}: any) {
    return <Link component={RouterLink} to={to}>{children}</Link>   
}